import desktopIcons from '../data/desktop-icons.json';
import type { DesktopIcon } from '../types/content';
import { dispatch, getState, subscribe } from '../state/store';
import { workArea } from './geometry';
import { iconUrl } from './icons';
import { applyDesktopBackground } from './wallpaper';
import { openApp } from './WindowManager';

const icons = desktopIcons as DesktopIcon[];

export function initDesktop(root: HTMLElement): void {
  root.classList.add('is-visible');
  applyDesktopBackground(root, getState());

  const grid = document.createElement('div');
  grid.className = 'desktop-icons';
  root.append(grid);

  const menu = document.createElement('div');
  menu.className = 'desk-menu';
  menu.hidden = true;
  const prop = document.createElement('button');
  prop.type = 'button';
  prop.textContent = 'Properties';
  prop.addEventListener('click', () => {
    menu.hidden = true;
    openApp('display');
  });
  menu.append(prop);
  root.append(menu);

  const hideMenu = () => {
    menu.hidden = true;
  };

  const paintIcons = () => {
    const area = workArea();
    const gutter = 16;
    const cellW = 108;
    const cellH = 108;
    grid.replaceChildren();
    for (const icon of icons) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'desk-icon';
      b.style.left = `${area.left + gutter + icon.col * cellW}px`;
      b.style.top = `${area.top + gutter + icon.row * cellH}px`;
      const img = document.createElement('img');
      img.className = 'desk-icon-glyph';
      img.alt = '';
      img.src = iconUrl(icon.icon);
      const label = document.createElement('span');
      label.className = 'desk-icon-label';
      label.textContent = icon.label;
      b.append(img, label);
      const open = () => {
        dispatch({ type: 'TOGGLE_START', open: false });
        hideMenu();
        openApp(icon.appId, icon.payload);
      };
      b.addEventListener('click', (e) => {
        e.stopPropagation();
        grid.querySelectorAll('.desk-icon').forEach((n) => n.classList.remove('is-selected'));
        b.classList.add('is-selected');
        open();
      });
      grid.append(b);
    }
  };

  root.addEventListener('click', () => {
    grid.querySelectorAll('.desk-icon').forEach((n) => n.classList.remove('is-selected'));
    hideMenu();
  });

  root.addEventListener('contextmenu', (e) => {
    if ((e.target as HTMLElement).closest('.desk-icon, .desk-menu')) return;
    e.preventDefault();
    menu.hidden = false;
    menu.style.left = `${e.clientX}px`;
    menu.style.top = `${e.clientY}px`;
  });

  paintIcons();
  window.addEventListener('resize', paintIcons);

  subscribe((_s, event) => {
    if (
      event.type === 'SET_WALLPAPER' ||
      event.type === 'SET_WALLPAPER_FIT' ||
      event.type === 'SET_DESKTOP_COLOR'
    ) {
      applyDesktopBackground(root, getState());
    }
  });
}
